import styled from 'styled-components';

import {StaticConfig} from 'config/staticConfig';
import {Breakpoints, Spacing} from 'styles/Base';

export const PAGE_PADDING = Spacing.TWO;
export const DOUBLE_PAGE_PADDING = Spacing.FOUR;

export const PageContainer = styled.div`
  margin: 0 auto;
  max-width: 63rem;
  padding: ${PAGE_PADDING};
  padding-bottom: 5rem;

  ${`@media (${Breakpoints.MOBILE})`} {
    padding: ${StaticConfig.mobileApplicationMode ? '1.5rem' : Spacing.TWO} ${Spacing.ONE};
  }

  ${`@media (${Breakpoints.TABLET})`} {
    padding-bottom: ${Spacing.ONE};
  }
`;

export const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${`@media (${Breakpoints.TABLET})`} {
    display: block;
  }
`;

export const PrimaryColumn = styled.div`
  flex: 2;
`;

export const SecondaryColumn = styled.div`
  margin: 0 0 0 ${Spacing.TWO};
  flex: 1;

  ${`@media (${Breakpoints.TABLET})`} {
    margin: ${Spacing.TWO} 0 0 0;
  }
`;
